import { SIZE_GAP } from '../accessories.service';

export const rodsMoveMethod = {
  moveUpCondition: item => {
    const { altitude } = item;
    return altitude + SIZE_GAP <= item.position[1];
  },
  moveDownCondition: item => {
    const { altitude } = item;
    return altitude - SIZE_GAP >= item.position[0];
  },
  moveUp(item, accessories, index) {
    const { protective_field, dimensions } = item;
    if (this.moveUpCondition(item)) {
      accessories[index] = {
        ...item,
        altitude: item.position[1],
        actualHeight: item.position[1] + protective_field + dimensions.y,
      };
    }
  },
  moveDown(item, accessories, index) {
    const { protective_field, dimensions } = item;

    if (this.moveDownCondition(item)) {
      accessories[index] = {
        ...item,
        altitude: item.position[0],
        actualHeight: item.position[0] + protective_field + dimensions.y,
      };
    }
  },
  switchAltitude: (prevAltitude, item, index) => {
    const { position } = item;
    const [min, max] = position;
    return index === 0 ? min : max;
  },
};

export const rodsCalcPositionMethod = (maxSpace, item, list) => {
  const { position } = item;

  const [min, max] = position;
  const prevItem = list[maxSpace.indexElement];

  if (list.length === 0) {
    return {
      ...maxSpace,
      position: max,
    };
  }

  if (list.length === 1 && prevItem.slug.includes('_dr_')) {
    return {
      ...maxSpace,
      position: prevItem.altitude === min ? max : min,
    };
  }

  if (list.length === 1 && prevItem.slug.includes('_al_bi4k')) {
    return {
      ...maxSpace,
      position: max,
    };
  }

  if (list.length > 0) {
    return {
      ...maxSpace,
      position: maxSpace.position > 0 ? max : min,
    };
  }

  return maxSpace;
};

export const rodsCalcIsSpaceEnough = (maxSpace, item, list) => {
  const { protective_field, dimensions } = item;
  const itemHeight = protective_field + dimensions.y;

  const prevItem = list[maxSpace.indexElement];

  if (prevItem) {
    const { protective_field: prevItemProtectiveField } = prevItem;

    return itemHeight - prevItemProtectiveField <= maxSpace.space;
  }

  return itemHeight <= maxSpace.space;
};

export const rodsCalcMaxPosition = (maxSpace, item, list) => {
  const { position } = item;
  const [, max] = position;

  const prevItem = list[maxSpace.indexElement];

  if (prevItem) {
    const { protective_field: prevItemProtectiveField } = prevItem;

    return maxSpace.position - prevItemProtectiveField <= max;
  }

  return maxSpace.position <= max;
};

export const rodsCalcMinPosition = (maxSpace, item, list) => {
  const rodsLength = list.filter(el => el.slug.includes('_dr_')).length;
  const itemWithoutLeds = list.filter(
    el => !el.slug.includes('_al_bi4k') && !el.slug.includes('_dr_'),
  ).length;

  if (rodsLength > 1) {
    return false;
  }

  if (rodsLength === 1 && itemWithoutLeds > 0) {
    return false;
  }

  return true;
};
